export const underwritingInfoSelector = (state) =>
  state.underwriting.underwritingInfo;
export const underwritingCarriersSelector = (state) =>
  state.underwriting.underwritingCarriersInfo;
export const underwritingLoadingSelector = (state) =>
  state.underwriting.isLoadingUnderwriting;
